(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rc-cart-offer"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.rcCartOfferLoaded) return;
    window.rcCartOfferLoaded = true;
    const pendingKey = 'rcCartOfferPending1';
    const subscribedKey = 'rcCartOfferSubscribed1';
    const offerCode = 'EARLYBIRD10';
    let applying = false;
    const root = () => window.Shopify?.routes?.root || '/';
    const read = (key) => { try { return sessionStorage.getItem(key); } catch { return null; } };
    const write = (key, value) => { try { sessionStorage.setItem(key, value); } catch {} };
    const remove = (key) => { try { sessionStorage.removeItem(key); } catch {} };
    const cards = () => [...document.querySelectorAll('[data-rc-cart-offer]')];
    const setStatus = (message, error = false) => {
      cards().forEach(card => {
        const status = card.querySelector('[data-offer-status]');
        if (!status) return;
        if (card.dataset.applied === 'true' && message === card.dataset.appliedMessage) {
          status.textContent = '';
          status.hidden = true;
          return;
        }
        status.textContent = message;
        status.dataset.error = String(error);
        status.hidden = !message;
      });
    };
    const setBusy = (busy) => {
      applying = busy;
      cards().forEach(card => {
        card.setAttribute('aria-busy', String(busy));
        card.querySelectorAll('button').forEach(button => { button.disabled = busy; });
      });
      document.querySelectorAll('.cart__checkout-button').forEach(button => {
        if (busy && !button.disabled) {
          button.dataset.rcOfferBusy = 'true';
          button.disabled = true;
        } else if (!busy && button.dataset.rcOfferBusy === 'true') {
          button.disabled = false;
          delete button.dataset.rcOfferBusy;
        }
      });
    };
    const allocations = cart => [
      ...(cart.cart_level_discount_applications || []),
      ...(cart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application))
    ];
    const hasPairOffer = cart => allocations(cart).some(application => /september treat|second[ -]reel/i.test(application.title || ''));
    const hasOffer = cart => (cart.discount_codes || []).some(code => code.code?.toUpperCase() === offerCode && code.applicable === true)
      || allocations(cart).some(application => application.type === 'discount_code' && application.title?.toUpperCase() === offerCode);
    const cartCodes = cart => [...new Set([
      ...(cart.discount_codes || []).filter(code => code.applicable).map(code => code.code),
      ...allocations(cart).filter(application => application.type === 'discount_code').map(application => application.title)
    ].filter(Boolean).map(code => code.toUpperCase()))];
    const syncSubscribed = () => {
      if (!read(subscribedKey)) return;
      cards().forEach(card => {
        if (card.dataset.applied === 'true' || card.dataset.pairOffer === 'true') return;
        card.querySelector('.rc-cart-offer__form')?.setAttribute('hidden', '');
        const retry = card.querySelector('[data-offer-retry]');
        if (retry) retry.hidden = false;
      });
    };
    const cleanClaimUrl = () => {
      const url = new URL(location.href);
      ['rc_cart_claim', 'rc_offer_token', 'customer_posted'].forEach(key => url.searchParams.delete(key));
      history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    };
    const refreshCart = async (cart, sectionId) => {
      const [{ morphSection }, { DiscountUpdateEvent }] = await Promise.all([
        import('@theme/section-renderer'), import('@theme/events')
      ]);
      document.dispatchEvent(new DiscountUpdateEvent(cart, 'rc-cart-offer'));
      const html = cart.sections?.[sectionId];
      if (html) morphSection(sectionId, html);
    };
    const applyOffer = async () => {
      if (applying || !read(subscribedKey)) return;
      const card = cards()[0];
      if (!card) return;
      const sectionId = card.dataset.sectionId;
      setBusy(true);
      setStatus(card.dataset.applyingLabel);
      try {
        const beforeResponse = await fetch(root() + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
        if (!beforeResponse.ok) throw new Error('cart_read');
        const before = await beforeResponse.json();
        if (hasOffer(before)) {
          setStatus(card.dataset.appliedMessage);
          return;
        }
        if (hasPairOffer(before)) {
          setStatus(card.dataset.conflictMessage, true);
          return;
        }
        const codes = cartCodes(before);
        if (!codes.includes(offerCode)) codes.push(offerCode);
        const payload = { discount: codes.join(',') };
        if (sectionId) {
          payload.sections = [sectionId];
          payload.sections_url = location.pathname + location.search;
        }
        const response = await fetch(root() + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(payload)
        });
        if (!response.ok) throw new Error('cart_update');
        const cart = await response.json();
        const active = hasOffer(cart);
        try { await refreshCart(cart, sectionId); } catch {
          if (active) {
            const destination = new URL(card.dataset.cartUrl || root() + 'cart', location.origin);
            const preview = new URL(location.href).searchParams.get('preview_theme_id');
            if (preview) destination.searchParams.set('preview_theme_id', preview);
            location.assign(destination.href);
            return;
          }
        }
        syncSubscribed();
        setStatus(active ? card.dataset.appliedMessage : hasPairOffer(cart) ? card.dataset.conflictMessage : card.dataset.unavailableMessage, !active);
      } catch {
        setStatus(card.dataset.errorMessage, true);
      } finally {
        setBusy(false);
        syncSubscribed();
      }
    };
    document.addEventListener('submit', event => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.matches('.rc-cart-offer__form') || !form.checkValidity()) return;
      const returnInput = form.querySelector('input[name="return_to"]');
      if (!returnInput) return;
      const token = window.crypto?.randomUUID?.() || String(Date.now()) + Math.random().toString(36).slice(2);
      const destination = new URL(form.closest('[data-rc-cart-offer]').dataset.cartUrl || root() + 'cart', location.origin);
      destination.searchParams.set('rc_cart_claim', '1');
      destination.searchParams.set('rc_offer_token', token);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) destination.searchParams.set('preview_theme_id', preview);
      const discountUrl = new URL(returnInput.value, location.origin);
      discountUrl.searchParams.set('redirect', destination.pathname + destination.search);
      returnInput.value = discountUrl.pathname + discountUrl.search;
      write(pendingKey, JSON.stringify({ token, created: Date.now() }));
    }, true);
    document.addEventListener('click', event => {
      if (!event.target.closest?.('[data-offer-retry]')) return;
      event.preventDefault();
      applyOffer();
    });
    const returnedFromSignup = async () => {
      const query = new URLSearchParams(location.search);
      let pending;
      try { pending = JSON.parse(read(pendingKey) || 'null'); } catch {}
      const elapsed = Date.now() - (pending?.created || 0);
      const recent = pending && elapsed >= 0 && elapsed < 30 * 60 * 1000;
      const returnedToken = query.get('rc_cart_claim') === '1' && pending?.token === query.get('rc_offer_token');
      const appliedOnReturn = cards().some(card => card.dataset.applied === 'true');
      const valid = recent && (returnedToken || appliedOnReturn);
      const failed = document.querySelector('[data-signup-errors]');
      if (query.get('rc_cart_claim') === '1') cleanClaimUrl();
      if (!valid || failed) { syncSubscribed(); return; }
      remove(pendingKey);
      write(subscribedKey, 'true');
      syncSubscribed();
      // Shopify's native discount redirect already applied the offer; avoid a redundant request.
      if (appliedOnReturn) return;
      await applyOffer();
    };
    document.addEventListener('cart:update', () => setTimeout(syncSubscribed, 100));
    document.addEventListener('discount:update', () => setTimeout(syncSubscribed, 100));
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', returnedFromSignup, { once: true });
    else returnedFromSignup();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rc-customization-controls"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.rcCustomizationV2Installed) return;
  window.rcCustomizationV2Installed = true;
  const roots = new WeakMap();
  const saved = new Map();
  const dropdowns = new WeakMap();
  let queued = false;
  let running = false;
  const clean = value => (value || '').replace(/\s+/g, ' ').trim();
  const formFor = root => root.closest('form') || document.querySelector('product-form-component[data-product-id="' + root.dataset.productId + '"] form');
  const labelOf = option => clean(option.querySelector('.po-label-label')?.textContent);
  const kindOf = label => {
    const name = label.toLowerCase();
    if (name.startsWith('how would you like your letters')) return 'letters';
    if (name.startsWith('reel style')) return 'reel';
    if (name.startsWith('add a colorful clip')) return 'clip';
    if (name.startsWith('extra whipped')) return 'extra';
    if (name.startsWith('letter upgrade')) return 'upgrade';
    if (name.includes('acrylic base')) return 'base';
    if (name.startsWith('design notes')) return 'notes';
    return 'other';
  };
  const orders = {letters:0,reel:20,clip:30,extra:40,upgrade:50,base:60,notes:90,other:10};
  const queue = () => {
    if (queued || running) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; refresh(); });
  };
  const selectedLabel = option => clean(option.querySelector('.po-select-selectedValue')?.textContent) || clean(option.querySelector('input[type="hidden"][name^="properties["]')?.value);
  const letterGroupFor = select => select.closest('[data-rc-custom-kind="upgrade"]')?.querySelector('[data-rc-palette-group="letters"]');
  function selectLetterMaterial(group, material) {
    const radio = [...(group?.querySelectorAll('[data-rc-palette-choice]') || [])].find(input => input.dataset.material === material && !input.disabled);
    if (!radio) return false;
    radio.checked = true;
    radio.dispatchEvent(new Event('change',{bubbles:true}));
    updatePalette(group);
    return true;
  }
  const syncTiles = (select, state) => {
    const selected = clean(select.querySelector('.po-select-selectedValue')?.textContent);
    const material = letterGroupFor(select)?.querySelector('[data-rc-palette-choice]:checked')?.dataset.material || 'original';
    const noUpgrade = selected === state.noUpgradeChoice;
    state.grid.querySelectorAll('button').forEach(button => {
      const active = button.dataset.letterMaterial
        ? noUpgrade && material === button.dataset.letterMaterial
        : selected === button.dataset.fullLabel || selected === button.dataset.choice || selected.startsWith(button.dataset.choice + ' (');
      button.setAttribute('aria-pressed', String(active));
    });
    if (state.noUpgradeChoice && /^color[\s-]*match/i.test(selected) && !state.busy) chooseNative(select,state,state.noUpgradeChoice,material);
  };
  const listItems = select => [...select.querySelectorAll('.po-select-listItem')];
  const choiceOf = item => clean(item.querySelector('.po-optionItemLabel-label')?.textContent);
  const settle = () => new Promise(resolve => setTimeout(resolve, 0));
  function appendTilePreview(button, source) {
    const nativeImage = source?.querySelector('img');
    if (nativeImage) {
      const image = document.createElement('img');
      image.src = nativeImage.currentSrc || nativeImage.src;
      image.alt = '';
      image.loading = 'eager';
      image.decoding = 'async';
      button.append(image);
      return;
    }
    const swatch = source?.querySelector('.rc-palettes__target');
    if (swatch) button.append(swatch.cloneNode(true));
  }
  async function openNative(select) {
    const trigger = select.querySelector('.po-select-button');
    if (!trigger || trigger.disabled) return [];
    if (trigger.getAttribute('aria-expanded') !== 'true') trigger.click();
    await settle();
    return listItems(select);
  }
  function closeNative(select) {
    const trigger = select.querySelector('.po-select-button');
    if (trigger?.getAttribute('aria-expanded') === 'true') trigger.click();
  }
  async function chooseNative(select, state, choice, material) {
    if (state.busy || !select.isConnected) return;
    state.busy = true;
    try {
      const group = letterGroupFor(select);
      const current = await openNative(select);
      const target = current.find(option => choiceOf(option) === choice);
      if (!target) return;
      target.click();
      await settle();
      closeNative(select);
      if (group) selectLetterMaterial(group,material || 'original');
    } finally {
      state.busy = false;
      syncTiles(select,state);
      queue();
    }
  }
  async function ensureGrid(select) {
    const known = dropdowns.get(select);
    if (known) { syncTiles(select, known); return; }
    const state = {busy:true,grid:document.createElement('div')};
    dropdowns.set(select, state);
    select.classList.add('rc-native-select','rc-grid-capturing');
    const items = await openNative(select);
    if (!items.length || !select.isConnected) {
      closeNative(select);
      dropdowns.delete(select);
      select.classList.remove('rc-grid-capturing');
      return;
    }
    state.grid.className = 'rc-option-grid';
    state.grid.setAttribute('role','group');
    state.grid.setAttribute('aria-label',labelOf(select.closest('.po-option-root')));
    const letterGroup = letterGroupFor(select);
    const config = letterGroup && roots.get(select.closest('.rc-custom-options')?.querySelector('[data-rc-palettes]'))?.config;
    const original = letterGroup?.querySelector('[data-rc-palette-choice][data-material="original"]');
    for (const item of items) {
      const choice = choiceOf(item);
      if (letterGroup && /^color[\s-]*match/i.test(choice)) continue;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'rc-option-tile';
      button.dataset.choice = choice;
      button.dataset.fullLabel = clean(item.querySelector('.po-optionItemLabel-labelRow')?.textContent);
      button.disabled = item.getAttribute('aria-disabled') === 'true' || !!item.querySelector('[aria-disabled="true"]');
      const noUpgrade = letterGroup && /^no thanks/i.test(choice);
      if (noUpgrade) {
        state.noUpgradeChoice = choice;
        button.dataset.letterMaterial = 'original';
      }
      appendTilePreview(button, noUpgrade ? original?.closest('label') : item);
      const text = document.createElement('span');
      text.textContent = noUpgrade ? config.original : button.dataset.fullLabel || button.dataset.choice;
      button.append(text);
      if (noUpgrade) {
        const note = document.createElement('small');
        note.textContent = config.included;
        button.append(note);
      }
      button.addEventListener('click',() => { if (!button.disabled) chooseNative(select,state,button.dataset.choice,'original'); });
      state.grid.append(button);
    }
    if (letterGroup && state.noUpgradeChoice) {
      letterGroup.querySelectorAll('[data-rc-palette-choice]').forEach(radio => {
        if (radio.dataset.material === 'original') return;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'rc-option-tile';
        button.dataset.letterMaterial = radio.dataset.material;
        button.disabled = radio.disabled;
        appendTilePreview(button, radio.closest('label'));
        const text = document.createElement('span');
        text.textContent = radio.dataset.label;
        const note = document.createElement('small');
        note.textContent = radio.disabled ? config.pending : config.included;
        button.append(text,note);
        button.addEventListener('click',() => { if (!button.disabled) chooseNative(select,state,state.noUpgradeChoice,radio.dataset.material); });
        state.grid.append(button);
      });
    }
    closeNative(select);
    select.append(state.grid);
    select.classList.remove('rc-grid-capturing');
    select.classList.add('rc-grid-ready');
    state.busy = false;
    syncTiles(select,state);
  }
  function nativeSelectGrid(select) {
    if (select.dataset.rcNativeGrid) return;
    select.dataset.rcNativeGrid = 'true';
    const grid = document.createElement('div');
    grid.className = 'rc-option-grid';
    [...select.options].forEach(option => {
      if (!option.value) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'rc-option-tile';
      button.textContent = option.text;
      button.disabled = option.disabled;
      button.dataset.value = option.value;
      button.addEventListener('click',() => {
        select.value = option.value;
        select.dispatchEvent(new Event('change',{bubbles:true}));
        sync();
      });
      grid.append(button);
    });
    const sync = () => grid.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.value === select.value)));
    select.after(grid);
    select.hidden = true;
    select.addEventListener('change',sync);
    sync();
  }
  function updatePalette(group) {
    const radio = group.querySelector('[data-rc-palette-choice]:checked');
    if (!radio) return;
    const text = group.querySelector('[data-rc-palette-selected]');
    if (text && text.textContent !== radio.dataset.label) text.textContent = radio.dataset.label;
    const hidden = group.querySelector('[data-rc-palette-material]');
    if (hidden) hidden.value = radio.dataset.material;
  }
  function syncLargeLetterWarning(root, info, form, config) {
    const textOption = [...info.querySelectorAll('.po-option-root[data-option-id]')].find(option => /^if customizing/i.test(labelOf(option)));
    const textInput = textOption?.querySelector('input[type="text"],textarea');
    const custom = /customize/i.test(info.querySelector('input[name="properties[Letter customization]"]')?.value || '');
    const count = (textInput?.value.match(/[a-z]/gi) || []).length;
    const useSmall = root.dataset.rcLargeLetterEligible === 'true' && root.dataset.rcMode === 'rtw' && custom && count > 4;
    let warning = textOption?.querySelector('[data-rc-large-letter-warning]');
    if (textInput && !warning && root.dataset.rcLargeLetterEligible === 'true') {
      warning = document.createElement('p');
      warning.className = 'rc-large-letter-warning';
      warning.dataset.rcLargeLetterWarning = '';
      warning.setAttribute('role','status');
      warning.setAttribute('aria-live','polite');
      warning.textContent = config.largeLetterWarning;
      textInput.closest('.po-field-root')?.append(warning);
    }
    if (warning) warning.hidden = !useSmall;
    let property = root.querySelector('[data-rc-small-letter-property]');
    if (useSmall && !property) {
      property = document.createElement('input');
      property.type = 'hidden';
      property.name = 'properties[Custom letter size]';
      property.value = 'Small letters';
      property.dataset.rcSmallLetterProperty = '';
      root.append(property);
    }
    if (property) {
      property.setAttribute('form',form.getAttribute('id'));
      property.disabled = !useSmall;
    }
  }
  function refresh() {
    if (running) return;
    running = true;
    document.querySelectorAll('[data-rc-palettes]').forEach(root => {
      const form = formFor(root);
      const info = root.closest('product-information,[data-product-information],.product-information') || document.querySelector('product-information,[data-product-information],.product-information');
      if (!form || !info) return;
      root.querySelectorAll('input').forEach(input => input.setAttribute('form',form.getAttribute('id')));
      let state = roots.get(root);
      if (!state) {
        const configNode = root.querySelector('[data-rc-customization-config]');
        if (!configNode) return;
        const config = JSON.parse(configNode.textContent);
        state = {config,groups:[...root.querySelectorAll('[data-rc-palette-group]')],expanded:new Map()};
        roots.set(root,state);
        const memory = saved.get(root.dataset.productId) || {};
        state.groups.forEach(group => {
          const radio = [...group.querySelectorAll('[data-rc-palette-choice]')].find(input => input.dataset.material === memory[group.dataset.rcPaletteGroup] && !input.disabled);
          if (radio) radio.checked = true;
        });
      }
      root.querySelectorAll('[data-rc-palette-group="letters"] img[loading="lazy"]').forEach(image => {
        image.loading = 'eager';
        image.decoding = 'async';
      });
      const checkedMode = info.querySelector('variant-picker input[type="radio"]:checked')?.value;
      const nativeId = form.querySelector('input[name="id"]')?.value;
      const mode = checkedMode || state.config.variants.find(variant => String(variant.id) === nativeId)?.title || '';
      const diy = /diy/i.test(mode);
      root.dataset.rcMode = diy ? 'diy' : 'rtw';
      state.groups.forEach(group => {
        const inactive = diy && group.dataset.rcPaletteGroup === 'cream';
        group.hidden = inactive;
        group.querySelectorAll('input').forEach(input => {
          input.setAttribute('form',form.getAttribute('id'));
          if (!input.hasAttribute('data-rc-original-disabled')) input.dataset.rcOriginalDisabled = String(input.disabled);
          input.disabled = inactive || input.dataset.rcOriginalDisabled === 'true';
        });
        updatePalette(group);
      });
      info.querySelectorAll('[data-rc-addons-heading],[data-rc-personalization-note][data-rc-inline="true"]').forEach(node => node.remove());
      info.querySelectorAll('[data-rc-option-toggle]:not([data-rc-custom-toggle])').forEach(node => node.remove());
      const optionNodes = [...info.querySelectorAll('.po-option-root[data-option-id]')].filter(node => !node.parentElement.closest('.po-option-root'));
      const container = optionNodes[0]?.parentElement;
      if (!container) {
        state.groups.forEach(group => { group.hidden = diy && group.dataset.rcPaletteGroup === 'cream'; updatePalette(group); });
        return;
      }
      container.classList.add('rc-custom-options');
      if (root.parentElement !== container) container.append(root);
      const seen = new Set();
      let upgrade;
      const activeIds = new Set();
      optionNodes.forEach(option => {
        const id = option.dataset.optionId;
        const label = labelOf(option);
        const kind = kindOf(label);
        const controlName = option.querySelector('input[name^="properties["]')?.name || label;
        const duplicate = seen.has(controlName);
        seen.add(controlName);
        if (duplicate) {
          option.hidden = true;
          option.querySelectorAll('input,select,textarea').forEach(control => { if (!control.disabled) { control.disabled = true; control.dataset.rcDuplicateDisabled = 'true'; } });
          return;
        }
        option.querySelectorAll('[data-rc-duplicate-disabled]').forEach(control => { control.disabled = false; delete control.dataset.rcDuplicateDisabled; });
        activeIds.add(id);
        const order = orders[kind];
        option.id = 'rc-custom-' + root.dataset.productId + '-' + id;
        option.classList.add('rc-custom-panel');
        option.classList.remove('rc-optional-option');
        option.dataset.rcCustomKind = kind;
        option.style.order = String(order + 1);
        if (kind === 'upgrade') upgrade = option;
        let toggle = [...container.querySelectorAll(':scope > [data-rc-custom-toggle]')].find(button => button.dataset.rcCustomToggle === id);
        if (!toggle) {
          toggle = document.createElement('button');
          toggle.type = 'button';
          toggle.className = 'rc-option-toggle rc-custom-toggle';
          toggle.id = 'rc-custom-toggle-' + root.dataset.productId + '-' + id;
          toggle.dataset.rcCustomToggle = id;
          toggle.dataset.rcOptionToggle = '';
          const title = document.createElement('strong');
          const plus = document.createElement('span');
          plus.className = 'rc-option-toggle__icon';
          plus.setAttribute('aria-hidden','true');
          plus.textContent = '+';
          toggle.append(title,plus);
          option.before(toggle);
          toggle.addEventListener('click',() => {
            state.expanded.set(id, toggle.getAttribute('aria-expanded') !== 'true');
            refresh();
          });
        }
        const title = toggle.querySelector('strong');
        const heading = state.config[kind] || label;
        if (title.textContent !== heading) title.textContent = heading;
        const customLetters = /customize/i.test(info.querySelector('input[name="properties[Letter customization]"]')?.value || '');
        const requiredText = kind === 'other' && (!!option.querySelector('.po-label-required') || (/^if customizing/i.test(label) && customLetters));
        const expanded = state.expanded.has(id) ? state.expanded.get(id) : kind === 'letters' || requiredText;
        toggle.style.setProperty('--rc-custom-order',String(order));
        toggle.setAttribute('aria-controls',option.id);
        toggle.setAttribute('aria-expanded',String(expanded));
        option.setAttribute('role','region');
        option.setAttribute('aria-labelledby',toggle.id);
        option.hidden = !expanded;
        option.querySelectorAll('.po-select-root').forEach(select => {
          if (!option.hidden) ensureGrid(select);
          const known = dropdowns.get(select);
          if (known && !known.busy) syncTiles(select,known);
        });
        option.querySelectorAll('.po-imageSwatches-optionItem').forEach(item => {
          item.setAttribute('role','button');
          item.tabIndex = 0;
          item.setAttribute('aria-pressed', String(!!item.querySelector('.po-imageOption-checked')));
          item.setAttribute('aria-label', clean(item.textContent));
        });
      });
      container.querySelectorAll(':scope > [data-rc-custom-toggle]').forEach(toggle => {
        if (!activeIds.has(toggle.dataset.rcCustomToggle)) toggle.remove();
      });
      state.groups.forEach(group => {
        const key = group.dataset.rcPaletteGroup;
        const merged = diy && key === 'letters' && !!upgrade;
        const target = merged ? upgrade : root;
        if (group.parentElement !== target) target.append(group);
        group.classList.toggle('rc-letters-merged',merged);
        if (!merged && group.dataset.rcWasMerged === 'true') group.open = false;
        group.dataset.rcWasMerged = String(merged);
        const inactive = diy && key === 'cream';
        group.hidden = inactive || merged;
        group.querySelectorAll('input').forEach(input => {
          input.setAttribute('form',form.getAttribute('id'));
          if (!input.hasAttribute('data-rc-original-disabled')) input.dataset.rcOriginalDisabled = String(input.disabled);
          input.disabled = inactive || input.dataset.rcOriginalDisabled === 'true';
        });
        updatePalette(group);
      });
      syncLargeLetterWarning(root,info,form,state.config);
      info.querySelectorAll('.rc-set-builder select').forEach(nativeSelectGrid);
    });
    running = false;
  }
  document.addEventListener('change',event => {
    const input = event.target;
    if (input.matches('[data-rc-palette-choice]')) {
      const form = input.form || input.closest('form');
      const root = document.querySelector('[data-rc-palettes][data-product-id="' + form?.closest('product-form-component')?.dataset.productId + '"]');
      const group = input.closest('[data-rc-palette-group]');
      if (root && group) {
        const memory = saved.get(root.dataset.productId) || {};
        memory[group.dataset.rcPaletteGroup] = input.dataset.material;
        saved.set(root.dataset.productId,memory);
        updatePalette(group);
      }
    }
    queue();
  });
  document.addEventListener('input',event => {
    const option = event.target.closest?.('.po-option-root[data-option-id]');
    if (!option || !/^if customizing/i.test(labelOf(option))) return;
    const info = option.closest('product-information,[data-product-information],.product-information');
    const root = info?.querySelector('[data-rc-palettes]');
    const form = root && formFor(root);
    const state = root && roots.get(root);
    if (root && form && state) syncLargeLetterWarning(root,info,form,state.config);
  });
  document.addEventListener('keydown',event => {
    const item = event.target.closest('.rc-custom-panel .po-imageSwatches-optionItem');
    if (item && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      item.querySelector('.po-imageOption-swatchLabel')?.click();
    }
  });
  document.addEventListener('invalid',event => {
    const option = event.target.closest('.rc-custom-panel');
    if (!option?.hidden) return;
    const info = option.closest('product-information,[data-product-information],.product-information');
    const root = info?.querySelector('[data-rc-palettes]');
    const state = roots.get(root);
    if (state) { state.expanded.set(option.dataset.optionId,true); refresh(); }
  },true);
  document.addEventListener('submit',refresh,true);
  document.addEventListener('variant:update',queue);
  document.addEventListener('shopify:section:load',queue);
  window.addEventListener('rc:customization-ready',queue);
  new MutationObserver(records => {
    if (records.some(record => record.type === 'childList' || record.attributeName === 'value' || record.target.matches?.('.po-imageOption-swatchLabel'))) queue();
  }).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['value','class']});
  refresh();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rc-product-palettes"] && !Shopify.designMode) return;
  try {
    window.dispatchEvent(new Event('rc:customization-ready'));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rc-review-form"] && !Shopify.designMode) return;
  try {
    function setupReviewContact(){
 document.querySelectorAll('.rc-rf').forEach(panel=>{
  if(panel.dataset.ready)return;panel.dataset.ready='true';
  const design=panel.querySelector('[data-review-design]');
  if(design&&!design.value){
    try{
      const saved=JSON.parse(sessionStorage.getItem('rc-review-return-182935978285')||'null');
      if(saved&&Date.now()-saved.time<7200000){
        const previous=new URL(saved.url,location.origin);
        if(previous.origin===location.origin&&previous.pathname.startsWith('/products/')){
          const match=Array.from(design.options).find(option=>option.dataset.productPath===previous.pathname);
          if(match){design.value=match.value;const help=panel.querySelector('[data-design-help]');help.textContent=help.dataset.autoCopy;}
        }
      }
    }catch{}
  }
  document.querySelectorAll('[data-open-review]').forEach(link=>link.addEventListener('click',()=>{panel.open=true}));
  if(location.hash==='#rc-write-review'||panel.querySelector('.rc-rf__result,.rc-rf__error'))panel.open=true;
  panel.querySelectorAll('input[type=text],textarea').forEach(input=>input.addEventListener('input',()=>input.setCustomValidity(input.required&&!input.value.trim()?'Please fill out this field.':'')));
 });
}
setupReviewContact();document.addEventListener('shopify:section:load',setupReviewContact);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["reelcute-announcement"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rc-announcement-rotator')) {
 customElements.define('rc-announcement-rotator',class extends HTMLElement {
  connectedCallback(){
   this.abort?.abort();this.abort=new AbortController();
   const options={signal:this.abort.signal};
   this.items=[...this.querySelectorAll('[data-announcement]')];
   if(this.items.length<2)return;
   this.index=0;this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
   this.pauseButton=this.querySelector('[data-announcement-pause]');
   this.querySelectorAll('[data-announcement-direction]').forEach(button=>button.addEventListener('click',()=>{this.show(this.index+Number(button.dataset.announcementDirection));this.schedule()},options));
   this.pauseButton.addEventListener('click',()=>{this.paused=!this.paused;this.updatePause();this.schedule()},options);
   this.addEventListener('mouseenter',()=>{this.hovered=true;this.schedule()},options);
   this.addEventListener('mouseleave',()=>{this.hovered=false;this.schedule()},options);
   this.addEventListener('focusin',()=>this.schedule(),options);
   this.addEventListener('focusout',()=>setTimeout(()=>this.schedule(),0),options);
   document.addEventListener('visibilitychange',()=>this.schedule(),options);
   this.updatePause();this.schedule();
  }
  show(index){this.index=(index+this.items.length)%this.items.length;this.items.forEach((item,i)=>{item.hidden=i!==this.index})}
  updatePause(){this.pauseButton.textContent=this.paused?this.pauseButton.dataset.playLabel:this.pauseButton.dataset.pauseLabel}
  schedule(){clearTimeout(this.timer);if(!this.isConnected||this.paused||this.hovered||this.contains(document.activeElement)||document.hidden)return;this.timer=setTimeout(()=>{this.show(this.index+1);this.schedule()},6500)}
  disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort()}
 });
}
  } catch(e) { console.error(e); }
})();

})();
